import { useContext, useState } from "react";
import CurrentContext from "./CurrentContext";
import styles from "./SmartObject.module.scss";

export default function OpenCloseToggle() {
  const {setAnimation} = useContext(CurrentContext);
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    setAnimation(checked);
  };

  return (
    <>
      <div className={styles.toggleAction}>
        <label className={styles.switch}>
          <input type="checkbox" checked={isChecked} onChange={handleToggle} />
          <span className={`${styles.slider} ${styles.round}`}>
            <span className={styles.toggleText}></span>
          </span>
        </label>
      </div>
    </>
  );
}
